import React from 'react';
import { number } from 'prop-types';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: '#828282',
    boxShadow: theme.shadows[1],
    maxWidth: 262,
    fontSize: 12,
    fontFamily: 'inherit',
    padding: 14,
  },
}))(Tooltip);

const EstimatedIR = ({ ir }) => {
  const invalidIr = Math.round(ir) < 20;
  return (
    <div className="ie--target--ir">
      <h4 className="ie--target--ir--title">
        <span>Estimated Incidence Rate</span>
        <HtmlTooltip
          title={
            <React.Fragment>
              We have removed the guess work and prepopulated the estimated
              incidence rate based on your targeting criteria. No need to adjust
              anything here.
            </React.Fragment>
          }
          placement="bottom-start"
        >
          <span className="ie--target--ir--tooltip">
            <svg
              className="MuiSvgIcon-root jss92"
              focusable="false"
              viewBox="0 0 24 24"
              aria-hidden="true"
              tabIndex="-1"
              title="Info"
              fill="#94a2b7"
              height="15px"
              width="15px"
            >
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
            </svg>
          </span>
        </HtmlTooltip>
      </h4>
      <div
        className={`ie--target--ir--box ${
          invalidIr ? 'ie--target--ir--box--invalid ' : ' '
        }`}
      >
        <div className="ie--target--ir--text">
          {Math.round(ir)}
          <span>%</span>
        </div>
        {invalidIr && (
          <div className="error">
            You have selected a very niche target. Please relax the targeting
            criteria to proceed
          </div>
        )}
      </div>
    </div>
  );
};

EstimatedIR.propTypes = {
  ir: number,
};

EstimatedIR.defaultProps = {
  ir: 100,
};

const mapStateToProps = ({ turnkeyOmnibus }) => ({
  ir: turnkeyOmnibus.surveyInfo.incidenceRate,
});

export default connect(
  mapStateToProps,
  null
)(EstimatedIR);
